/**
 * Central de notificações (redesign admin, Fase 4). Puro e sem I/O: recortes de
 * apresentação sobre `PlatformNotification[]` do admin-runtime. Marcar como lida
 * não existe no cliente da Plataforma (sem contrato de escrita): a tela é
 * somente leitura.
 */
import type { PlatformNotification } from "../api/types.js";

export type NotificationSeverityFilter = PlatformNotification["severity"] | "todas";
export type NotificationReadFilter = "todas" | "nao-lidas";

const SEVERITY_RANK: Record<PlatformNotification["severity"], number> = { critical: 0, warning: 1, info: 2 };

export function filterNotifications(
  notifications: PlatformNotification[],
  severity: NotificationSeverityFilter,
  read: NotificationReadFilter
): PlatformNotification[] {
  return notifications
    .filter((n) => (severity === "todas" || n.severity === severity) && (read === "todas" || !n.read))
    // Não lidas e mais graves primeiro; empate: mais recente.
    .sort(
      (a, b) =>
        Number(a.read) - Number(b.read) ||
        SEVERITY_RANK[a.severity] - SEVERITY_RANK[b.severity] ||
        b.created_at.localeCompare(a.created_at)
    );
}

export function notificationCounts(notifications: PlatformNotification[]): { total: number; unread: number; critical: number } {
  return {
    total: notifications.length,
    unread: notifications.filter((n) => !n.read).length,
    critical: notifications.filter((n) => !n.read && n.severity === "critical").length
  };
}

export const SEVERITY_LABELS: Record<PlatformNotification["severity"], string> = {
  critical: "Crítica",
  warning: "Atenção",
  info: "Informativa"
};
